<template>
  <div class="wrap_footer">
    <el-pagination
        background
        :current-page="currentPage"
        @size-change="handleChangeSize"
        @current-change="handleChangePage"
        :page-sizes="$pageListDefaultNew"
        :page-size="maxPageItem"
        :layout="$pageLayoutDefault"
        :total="totalElements"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "AbsentLetterFooter",
  props: {
    page: {type: Number, default: 0, required: true},
    limit: {type: Number, default: 0, required: true},
    total: {type: Number, default: 0, required: true},
  },
  data() {
    return {
      currentPage: this.page,
      maxPageItem: this.limit,
      totalElements: this.total,
    }
  },
  watch: {
    page(v) {
      this.currentPage = v
    },
    limit(v) {
      this.maxPageItem = v
    },
    total(v) {
      this.totalElements = v
    }
  },
  methods: {
    handleChangeSize(v) {
      this.maxPageItem = v;
      this.onchangePage();
    },
    handleChangePage(v) {
      this.currentPage = v;
      this.onchangePage();
    },
    onchangePage() {
      this.$emit("change", {
        page: this.currentPage,
        limit: this.maxPageItem,
      });
    }
  }
}
</script>

<style scoped lang="scss">
.wrap_footer {
  ::v-deep .el-pagination {
    display: flex;
    justify-content: center;
  }
}
</style>